import { LoginCard } from "./components";

export const SignIn = () => {
  return (
    <main className="min-h-screen bg-white">
      <section className="relative min-h-[calc(100vh-170px)] md:min-h-[calc(100vh-80px)] overflow-hidden">
        <div className="absolute inset-0 h-176.75 md:h-161.5">
          <div
            className="absolute inset-0 bg-cover bg-center md:hidden"
            style={{
              backgroundImage: "url('/images/login-header-bg-mobile.png')",
            }}
          />

          <div
            className="absolute inset-0 hidden bg-cover bg-center md:block"
            style={{
              backgroundImage: "url('/images/login-header-bg.png')",
            }}
          />
        </div>
        <div className="relative z-10 md:flex-row flex-col gap-10 flex items-center justify-center px-4 pt-8 md:pt-32 md:pb-0">
          <img
            src="/images/vac-logo.png"
            alt="VAC"
            className="h-22.25 w-47.25 block md:hidden"
          />
          <LoginCard />
        </div>
      </section>
      <section className="hidden md:block mx-auto w-92.25 h-112.75 md:w-197.25 md:h-55 text-center px-4">
        <p className="text-body-1 font-kalameh text-[#333333] px-12">
          تو این مینی دوره در قالب ۳ فصل، نقشه راه رشد سریع صدات رو بهت نشون
          دادم وقتی به آخر ویدیوی سوم برسی تو آماده ای برای برداشتن یک قدم جدی
          برای رشد صدات و حرفه ای تر خوندنت
        </p>

        <p className="mt-8 text-body-1 font-kalameh text-[#333333] px-36">
          راستی دقت کن فقط ۳ روز برای دیدن مینی دوره فرصت داری پایان این مینی
          دوره یه سورپرایز جذاب در انتظارته!
        </p>
      </section>
      <section className="block md:hidden mx-auto w-full h-112.75 text-center mt-5">
        <p className="text-body-1 font-kalameh text-[#333333] px-20">
          تو این مینی دوره در قالب ۳ فصل، نقشه راه رشد سریع صدات رو بهت نشون
          دادم
        </p>
        <p className="mt-0.5 text-body-1 font-kalameh text-[#333333] px-14">
          وقتی به آخر ویدیوی سوم برسی تو آماده ای برای برداشتن یک قدم جدی برای
          رشد صدات و حرفه ای تر خوندنت
        </p>
        <p className="mt-10 text-body-1 font-kalameh text-[#333333] px-16">
          راستی دقت کن فقط ۳ روز برای دیدن مینی دوره فرصت داری
        </p>
        <p className="mt-0.5 text-body-1 font-kalameh text-[#333333] px-10">
          پایان این مینی دوره یه سورپرایز جذاب در انتظارته!
        </p>
      </section>
    </main>
  );
};
